import { useEffect } from 'react';
import { useLanguageStore } from '../store/languageStore';

// Languages that are RTL
const RTL_LANGUAGES: string[] = ['he'];

export function useDirection() {
  const language = useLanguageStore((state) => state.language);

  useEffect(() => {
    const isRTL = RTL_LANGUAGES.includes(language);
    const dir = isRTL ? 'rtl' : 'ltr';
    const langMap: Record<string, string> = {
      he: 'he',
      en: 'en',
      ru: 'ru',
      si: 'si',
      uz: 'uz',
      ro: 'ro',
    };
    const lang = langMap[language] || 'en';

    // Update HTML element
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);

    // Update body direction
    document.body.setAttribute('dir', dir);
    document.body.style.direction = dir;

    // Add/remove RTL class for easier CSS targeting
    if (isRTL) {
      document.documentElement.classList.add('rtl');
      document.documentElement.classList.remove('ltr');
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.documentElement.classList.add('ltr');
      document.documentElement.classList.remove('rtl');
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, [language]);
}

